<template>
    <div class="animated fadeIn">
        <b-card>
            <div slot="header">Inventory Receipt Form
                <div class="card-header-actions">
                    <button class="btn btn-primary mr-1" @click="save()">
                        <i class="fa fa-save"></i> Save
                    </button>
                    <b-button class="btn btn-danger mr-1" @click="close()"> <i class="fa fa-close"></i> Cancel</b-button>
                </div>
            </div>
        <b-row h-align="center">
            <b-col lg="7">
                <b-row>
                    <b-col lg="7">
                        <b-input-group>
                            <b-input-group-prepend><label>Receiving Date</label></b-input-group-prepend>
                            <b-form-input v-model="frmdata.recivDate" type="date" :state="!$v.frmdata.recivDate.$error"></b-form-input>
                        </b-input-group>
                    </b-col>
                    <b-col lg="5">
                        <b-input-group>
                            <b-input-group-prepend><span class="p-2">P.O. Number</span></b-input-group-prepend>
                            <b-form-input v-model="frmdata.purcOrderNo" ></b-form-input>
                        </b-input-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="7">
                        <b-input-group>
                            <b-input-group-prepend><label>Receiving No.</label></b-input-group-prepend>
                            <b-form-input v-model="frmdata.purcRcpHdNo"></b-form-input>
                        </b-input-group>
                    </b-col>
                    <b-col lg="5">
                        <b-input-group>
                            <b-input-group-prepend><span class="p-2">D.O vendor#</span></b-input-group-prepend>
                            <b-form-input v-model="frmdata.vndShipNo" ></b-form-input>
                        </b-input-group>
                    </b-col>
                </b-row>
                <b-input-group>
                    <b-input-group-prepend><label>Inventory ItemCode</label></b-input-group-prepend>
                    <b-form-input readonly v-model="frmdata.partnumber" :state="!$v.frmdata.itemno.$error"></b-form-input>
                    <b-form-input readonly v-model="frmdata.itemname" :state="!$v.frmdata.itemno.$error" style="width:30% !important;"></b-form-input>
                    <b-input-group-append>
                    <b-btn text="Button" @click="lkuItemShow=true" >
                        <i class="fa fa-search"></i>
                    </b-btn>
                    </b-input-group-append>
                </b-input-group>
                <b-input-group>
                    <b-input-group-prepend><label>Model/Type/Series</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.typeseries"></b-form-input>
                </b-input-group>
                <b-row no-gutters>
                  <b-col lg="8">                            
                        <b-input-group>
                            <b-input-group-prepend><label>Inventory Group</label></b-input-group-prepend>
                            <b-form-select v-model="frmdata.inven_catid" :plain="true" :options="headCategories" :state="!$v.frmdata.inven_catid.$error" class="mr-2"></b-form-select>
                            <b-form-checkbox class="ml-1 mt-2" v-model="frmdata.off_bs" value="1" unchecked-value="0">Off BS</b-form-checkbox>
                        </b-input-group>
                  </b-col>
                  <b-col lg="4">
                      <b-input-group>
                          <b-input-group-prepend><label class="text-right" style="width:135px;">Status/Condition</label></b-input-group-prepend>
                        <b-form-select v-model="itemCondition" :options="conditionOpt" :plain="true"></b-form-select>
                      </b-input-group>
                  </b-col>
                </b-row >                      
                <!-- <b-input-group>
                    <b-input-group-prepend><label>Item Name</label></b-input-group-prepend>
                    <b-form-input readonly v-model="frmdata.itemname"></b-form-input>
                </b-input-group> -->
                <!-- <b-input-group>
                    <b-input-group-prepend><label>Inventory Group</label></b-input-group-prepend>
                    <b-form-select v-model="frmdata.inven_catid" :plain="true" :options="headCategories" :state="!$v.frmdata.inven_catid.$error"></b-form-select>
                </b-input-group> -->
                <b-input-group>
                    <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.description" :state="!$v.frmdata.description.$error"></b-form-input>
                </b-input-group>
              <b-row>
                <b-col lg="6"> 
                  <b-input-group>
                      <b-input-group-prepend><label>Qty Inventory IN</label></b-input-group-prepend>
                      <b-form-input v-model="frmdata.quantity" type="number" :state="!$v.frmdata.quantity.$error" :min="1" v-if="(frmdata.ishasserialno!=1)"></b-form-input>
                      <b-form-input v-model="frmdata.quantity" type="number" :state="!$v.frmdata.quantity.$error" :min="1" v-else readonly v-b-tooltip.hover title="Item has SERIAL NUMBER, must be receipt one by one"></b-form-input>
                      <b-form-input v-model="frmdata.invunitom" class="ml-1" :state="!$v.frmdata.invunitom.$error" :disabled="(frmdata.ishasserialno==1)"></b-form-input>
                  </b-input-group>
                </b-col>                  
                  <b-col lg="6">                            
                      <b-input-group>
                          <b-input-group-prepend><label>Inventory Unit price</label></b-input-group-prepend>
                          <b-input-group-prepend>
                          <span class="input-group-text" >{{uanguser}}</span>
                          </b-input-group-prepend>
                          <my-number class="form-control text-right" v-model="frmdata.invUnitCost" :precision="2" ></my-number>
                      </b-input-group>
                  </b-col>
              </b-row >                      
              <b-row>
                  <b-col lg="7">                            
                      <b-input-group>
                          <b-input-group-prepend><label>Store/Warehouse </label></b-input-group-prepend>
                          <b-form-select v-model="frmdata.idStore" :plain="true" :options="warehouse" :state="!$v.frmdata.idStore.$error"></b-form-select>
                      </b-input-group>
                  </b-col>
                  <b-col lg="5">                            
                      <b-input-group>
                          <b-input-group-prepend><label style="width:113px !important; text-align:right;">Rack/Shelf No.</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.shelfNo" :state="!$v.frmdata.shelfNo.$error"></b-form-input>
                      </b-input-group>
                  </b-col>
              </b-row >     
              <!-- <b-row>
                  <b-col lg="7">                            
                      <b-input-group v-if="frmdata.isexpireable">
                          <b-input-group-prepend><label>Expired Date</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.expirDate" type="date" :state="!$v.frmdata.expirDate.$error"></b-form-input>
                      </b-input-group>
                      <b-input-group v-if="frmdata.ishasserialno">
                          <b-input-group-prepend><label>Serial Number</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.serialNum" :state="!$v.frmdata.serialNum.$error"></b-form-input>
                      </b-input-group>
                  </b-col>
              </b-row >      -->
              <b-row>
                  <b-col lg="7">                            
                      <b-input-group v-if="frmdata.isexpireable">
                          <b-input-group-prepend><label>Expired Date</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.expirDate" type="date" :state="!$v.frmdata.expirDate.$error"></b-form-input>
                      </b-input-group>
                      <b-input-group v-if="frmdata.ishasserialno">
                          <b-input-group-prepend><label>Serial Number</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.serialNum" :state="!$v.frmdata.serialNum.$error"></b-form-input>
                      </b-input-group>
                  </b-col>
                  <b-col lg="5">                            
                      <b-input-group v-if="((frmdata.itemUsageType=='FIXED ASSET') && ((frmdata.barangbekas==1) || (frmdata.barangrusak==1)))">
                    <b-input-group-prepend><label class="text-right">No. Fixed Asset</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.fixAsetid" readonly></b-form-input>
                      </b-input-group>
                  </b-col>
              </b-row >     
            </b-col>
            <b-col lg="5">
              <v-dim :model="frmdata" ></v-dim>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-2">
            <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
            </button>
            <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Cancel</b-button>
        </b-row>
        
    </b-card>
    <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item Inventory" :centered="true">
            <lku-item @click="onSelectLkuItem"  jasa="0" isactive="1" :formdata="itemList" ></lku-item>
    </b-modal>        

    </div>
</template>


<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import lkuItem from "../lookup/lkuItemLazzy";
import vDim from "../lookup/dim";
import inv from "../../apis/logistic_inv_in";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: { myNumber,lkuItem,vDim},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        recivDate: {required},
        quantity: { required },
        invUnitCost: { required },
        invunitom: { required },
        itemno: { required },
        inven_catid: { required },
        description: { required },
        invUnitCost: { required },
        idStore : { required },
        shelfNo : { required },
        serialNum: { required:requiredIf('ishasserialno') },
        expirDate: { required:requiredIf('isexpireable') }
    },
  },
  data() {
    return {
      showList:true,
      showForm:false,
      showGCIF:false,
      lkuItemShow:false,
      itemList:{},
      frmdata:{ishasserialno:0, isexpireable:0,quantity: '', off_bs:0, invunitom: '',qtykonversi:1, gcif:0 , receiptSrc: 'OTHER',
      barangbekas:0,barangrusak:0,itemUsageType:'CONSUMABLE'
      },
      uanguser: this.$store.state.user.matauang,
      warehouse:[],headCategories:[],
      conditionOpt:[
        { value: { barangbekas:0,barangrusak:0 }, text: 'Baru'},
        {value: { barangbekas:1,barangrusak:0 }, text: 'Bekas'},
        {value: { barangbekas:0,barangrusak:1 }, text: 'Rusak'},
      ],
      itemCondition:{},
    };
  },
    computed: {
        // dimension(){
        //   return this.$store.state.dimension;
        // },
        isexpireable() {
            return this.frmdata.isexpireable;
        },
        ishasserialno() {
            return this.frmdata.ishasserialno;
        },
        invalidFormdata() {
            this.$v.frmdata.$touch();
            return this.$v.frmdata.$invalid;
        },

    },
    watch:{
        itemCondition(val){
            for (const element in val) {
                this.frmdata[element] = val[element];
            }
        },
    },
    created: async function () {
        const [a, b] = await Promise.all([inv.inventorygroup(), inv.store()]);
        this.headCategories = a;
        this.warehouse = b;
        if (b[0]) {
            this.frmdata.idStore= b[0].value;
        }   

    },
  methods: {
    onSelectLkuItem:  function (lkuData) {
        this.itemList=lkuData;
        this.lkuItemShow=false;

        this.frmdata.iteminfo = lkuData.selected.partnumber.trim() + ' | ' + lkuData.selected.itemname.trim();
        this.frmdata.itemno = lkuData.selected.itemno;
        this.frmdata.itemname = lkuData.selected.itemname;
        this.frmdata.isexpireable = lkuData.selected.isexpireable;
        this.frmdata.ishasserialno = lkuData.selected.ishasserialno;
        this.frmdata.invunitom = lkuData.selected.invunitom;
        this.frmdata.unitsize = lkuData.selected.unitsize;
        this.frmdata.itemcategory = lkuData.selected.itemcategory;
        // this.frmdata.typeseries = lkuData.selected.typeseries;
        this.frmdata.partnumber = lkuData.selected.partnumber;
        this.frmdata.konsinyasi = lkuData.selected.konsinyasi;
        this.frmdata.qtyUndefined = lkuData.selected.qtyUndefined;
        if (lkuData.selected.inven_catid){
          this.frmdata.inven_catid=lkuData.selected.inven_catid
        }
        // if (lkuData.selected.invenDbAcc) {
        //     const ada = this.headCategories.find(c => c.kodeacc==lkuData.selected.invenDbAcc);
        //     if (ada) {
        //         this.frmdata.inven_catid=lkuData.selected.invenDbAcc
        //     }
        // }
        if (this.frmdata.ishasserialno==1) {
            this.frmdata.quantity=1;
            this.frmdata.qtykonversi=1;
            this.frmdata.qtyPurcRcp=1
            this.frmdata.invunitom=this.frmdata.unitsize;
        }
    },
        
    save: async function (callback) {
            if (this.invalidFormdata) {

                const invalidobj = {};
                for (var key in this.$v.frmdata) {
                    if (this.$v.frmdata[key].$anyError) {
                        if (this.$v.frmdata[key].$anyError == true)
                            invalidobj[key] = this.$v.frmdata[key];
                    }
                }
                console.log("validation field: ", invalidobj);
                console.log("selected : ", this.frmdata);
                toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
            } else {
                try {
                    // Note apakah perlu dibuatkan validation saat input gcif
                    // this.frmdata.gcifData = this.frmGCIFdata;
                    // const result = await inv.invReceipt_save(this.frmdata);
                    this.frmdata.invValue = this.frmdata.invUnitCost * this.frmdata.quantity;
                    this.frmdata.invValueFCY = this.frmdata.invValue;
                    this.frmdata.invUnitCostFCY = this.frmdata.invUnitCost;
                    this.frmdata.purcOrderNo = (this.frmdata.barangbekas == 1) ? 'BEKAS' : this.frmdata.purcOrderNo;
                    await inv.save(this.frmdata);
                    this.showGCIF = false;
                    this.showForm = false;
                    toastr.success("Complete successfully", "Save Inventory Receipt");
                    router.push({ name: 'logistic.inv_in' });
                } catch (error) {
                    // this.saveEnabled=true;
                    // this.isLoading=false;
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        },
        close() {
            router.push({ name: 'logistic.inv_in' });
        },
    }
};
</script>
